import axios from 'axios';
import {Notification} from 'element-ui';
import * as R from 'ramda';
import hosts from '@/config/hosts';
import router from '@/router';
// import tip from '@/utils/tip';

// 基本的接口公共配置
const baseRequestConfig = {
  baseURL: hosts('main'),
  // 我们要的可是10整秒!!
  timeout: (1000 * 60 * 5),
  withCredentials: true,
};

// 出错的回调
const errorCallback = (error) => {
  const response = error.response;
  const {status, data, request} = response;
  if (status === 401) {
    return Promise.reject(new Error('login failed'));
  }
  if (status !== 200) {
    if (R.is(Object, data) && R.prop('msg', data)) {
      Notification({
        title: '接口请求错误',
        message: data.msg,
        customClass: 'global-notification',
        type: 'error',
        duration: 4000,
      });
    } else {
      Notification({
        title: '接口请求错误',
        message: `status: ${status}; url: ${request.responseURL}`,
        customClass: 'global-notification',
        type: 'error',
        duration: 4000,
      });
    }
    // 返回reject会导致api层handle .resolve的逻辑执行不下去
    // 导致业务代码的异常处理代码执行不到
    return Promise.resolve(response);
  }
  return Promise.resolve(response);
};

// 下载文件接口
const Download = axios.create({
  ...baseRequestConfig,
  responseType: 'blob',
});
Download.interceptors.response.use(res => res, errorCallback);

// 报表接口
const Tableau = axios.create(R.merge(baseRequestConfig, {
  baseURL: hosts('tableau'),
}));
Tableau.interceptors.response.use(res => res, errorCallback);

// 短信发送接口
const Common = axios.create(R.merge(baseRequestConfig, {
  baseURL: hosts('common'),
}));
Common.interceptors.response.use(res => res, errorCallback);

const Root = axios.create(R.merge(baseRequestConfig, {
  baseURL: hosts('root'),
}));
Root.interceptors.response.use(res => res, errorCallback);

// 普通json接口
const Ax = axios.create(baseRequestConfig);

Ax.interceptors.request.use((config) => R.merge(config, {
  startSt: Date.now(),
}));

Ax.interceptors.response.use((response) => {
  if (response.config.url !== 'login') {
    try {
      if (response.data) {
        const code = response.data.code;
        if (code !== 10000) {
          if (code === 19000) {
            // tip.warning('登录失效请重新登录');
            router.push({name: 'Login'});
          } else {
            throw new Error(response.data.msg || '接口发生未知错误');
          }
        }
      } else {
        throw new Error('网络异常');
      }
    } catch (e) {
      let msg;
      const maxLength = 40;
      if (R.is(String, e) && (e.length > maxLength)) {
        msg = `${e.slice(0, maxLength)}...`;
      } else {
        msg = e;
      }
      Notification({
        title: '接口请求错误',
        // message: `url:${response.request.responseURL}; msg:${msg}`,
        message: `${msg}`,
        customClass: 'global-notification',
        type: 'error',
        duration: 4000,
      });
    }
  }
  return response;
}, errorCallback);

export {
  Ax as default,
  Download,
  Tableau,
  Common,
  Root,
};



// WEBPACK FOOTER //
// ./src/api/Ax.js